import React, { useContext, createContext, useMemo } from "react";
import PropTypes from "kf-proptypes/base";

import { useBaseAppDevStore } from "../stores/app.store.js";

const ThemeContext = createContext({ themeClass: "" });

export function useTheme() {
  return useContext(ThemeContext);
}

export function ThemeProvider({ appId: appIdProp, children }) {
  let appId = appIdProp || useBaseAppDevStore.getState().currentAppId;
  let state = useMemo(
    function getThemeClassName() {
      return { themeClass: appId ? `appTheme_${appId}` : "" };
    },
    [appId]
  );
  return (
    <ThemeContext.Provider value={state}>{children}</ThemeContext.Provider>
  );
}

ThemeProvider.propTypes = {
  appId: PropTypes.string,
  children: PropTypes.node
};
